import api from '@/api/shelter-status'

export default {
  state: {
    statuses: []
  },
  mutations: {
    setStatuses (state, value) {
      state.statuses = value
    }
  },
  actions: {
    create (store, params) {
      return api.create(params)
    },
    fetch ({commit}, params) {
      return api.get(params)
        .then((res) => {
          commit('setStatuses', res.data.data)
        })
    }
  },
  getters: {
    statuses: (state) => state.statuses
  },
  namespaced: true
}
